import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { CoreModule } from '@abp/ng.core';
import { KENDO_DATETIMEPICKER } from '@progress/kendo-angular-dateinputs';
import { KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_FLOATINGLABEL } from '@progress/kendo-angular-label';

import { IssueDeactivationInstruction } from '../../../models';

@Component({
  selector: 'nexweb-deactivation-notification-form',
  templateUrl: './deactivation-notification-form.component.html',
  imports: [CoreModule, KENDO_TEXTBOX, KENDO_FLOATINGLABEL, KENDO_DATETIMEPICKER],
})
export class DeactivationNotificationFormComponent implements OnInit {
  @Input() notification: IssueDeactivationInstruction.DeactivationInstruction;
  @Input() labels: IssueDeactivationInstruction.Labels;
  @Input() headings: IssueDeactivationInstruction.Headings;
  @Input() dateTimeFormat: string;

  public deactivationFormGroup: FormGroup;

  ngOnInit(): void {
    this.initialise();
  }

  public initialise(): void {
    this.deactivationFormGroup = new FormGroup({
      name: new FormControl({
        value: this.notification.tsoName,
        disabled: true,
      }),
      telephoneNumber: new FormControl({
        value: this.notification.tsoTelephoneNumber,
        disabled: true,
      }),
      portfolio: new FormControl({
        value: this.notification.tsoPortfolio,
        disabled: true,
      }),
      quantity: new FormControl({
        value: this.notification.orderQuantity,
        disabled: true,
      }),
      confirmedFullDispatchTime: new FormControl({
        value: this.notification.confirmedFullDispatchTime,
        disabled: true,
      }),
      fullyDeactivatedTime: new FormControl({
        value: this.notification.fullyDeactivatedTime,
        disabled: true,
      }),
      // acknowledgeMessageRead: new FormControl({
      //   value: false,
      // }),
    });
  }
}
